import { useEffect } from "react";
import { useDispatch, useSelector } from "../../hooks";
import { getCollections } from "../../redux/collections/get-collections.handler";
import { Loader } from "../../components/Loader/Loader";
import { ErrorSnackbar } from "../../components/ErrorSnackbar/ErrorSnackbar";
import { ContentWrapper } from "../../components/ContentWrapper/ContentWrapper";
import { PageTitleBlock } from "../../components/PageTitleBlock/PageTitleBlock";
import { CardWrapper } from "../../components/CardWrapper/CardWrapper";
import styles from "./CollectionsPage.module.scss";
import { CollectionCard } from "../../components/CollectionCard/CollectionCard";

export const CollectionsPage = () => {
    const dispatch = useDispatch();
    const { items: collections, loading, error } = useSelector(store => store.collections);

    useEffect(() => {
        dispatch(getCollections());
    }, [dispatch]);

    return (
        <>
            <ContentWrapper>
                <div className={styles.wrapper}>
                    <PageTitleBlock pageTitle={"Коллекции"} />
                    
                    <CardWrapper>
                        {collections.map(collection => (
                            <CollectionCard
                                key={`collection${collection.collectionId}`}
                                { ...collection }
                            />
                        ))}
                    </CardWrapper>
                </div>
            </ContentWrapper>

            { loading && <Loader /> }
            { error.length > 0 && <ErrorSnackbar errorMessage={ error } /> }
        </>
    );
};